( function() {
	jQuery('.testims-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1
	});
	jQuery('.hp-client-logos').slick({
		slidesToShow: 6,
		slidesToScroll: 6,
		responsive: [
		{
		  breakpoint: 800,
		  settings: {
			slidesToShow: 4,
			slidesToScroll: 4
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		  }
		}
	  ]
	});
	jQuery('.timeline-slider').slick({
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
		{
		  breakpoint: 700,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	  ]
	});
	
	var countup = function() {
		jQuery('.counter').each(function() {
			var $this = jQuery(this),
			countTo = $this.attr('data-count');
			jQuery({ countNum: $this.text()}).animate({
				countNum: countTo
			},
			{
				duration: 2000,
				easing:'linear',
				step: function() {
					$this.text(Math.floor(this.countNum));
				},
				complete: function() {
					$this.text(this.countNum);
				}
			});  
		});
	};
	
	//Team Bio overlays
	jQuery(".team-member").click(function(){
		jQuery(this).next(".team-member-overlay").fadeIn("fast");
	});
	jQuery(".team-member-overlay").click(function(e){
		if(jQuery(e.target).is('i.fa-times')){
			jQuery(".team-member-overlay").fadeOut("fast");
		} else if(!jQuery(e.target).closest('.overlay-wrap').length) {
			jQuery(".team-member-overlay").fadeOut("fast");
		}   
	});
	
	
	//Viewportchecker
	jQuery('.animated').viewportChecker({
		classToAdd: 'fadeInUp', // Class to add to the elements when they are visible,
	});
	jQuery('.top_three_blocks').viewportChecker({
		callbackFunction: function(){
			jQuery(".top_three_blocks .onethird").each(function () {		
				var $threeblocks = jQuery(".top_three_blocks .onethird"), counter = 0;
				setInterval(function(){
				  $threeblocks.eq(counter++ % $threeblocks.length).addClass("animated fadeInUp");
				}, 200);
			});
		}
	});
	jQuery('.latest-news').viewportChecker({
		callbackFunction: function(){
			jQuery(".latest-news .quarter").each(function () {		
				var $latestNews = jQuery(".latest-news .quarter"), counter = 0;
				setInterval(function(){
				  $latestNews.eq(counter++ % $latestNews.length).addClass("animated fadeInUp");
				}, 200);
			});
		}
	});
	jQuery('.timeline-slider').viewportChecker({
		callbackFunction: function(){
			jQuery(".timeline-slide").each(function () {		
				var $latestNews = jQuery(".timeline-slide"), counter = 0;
				setInterval(function(){
				  $latestNews.eq(counter++ % $latestNews.length).addClass("animated fadeInUp");
				}, 200);
			});
		}
	});
	jQuery('.contact-locations').viewportChecker({
		callbackFunction: function(){
			jQuery(".contact-location").each(function () {		
				var $latestNews = jQuery(".contact-location"), counter = 0;
				setInterval(function(){
				  $latestNews.eq(counter++ % $latestNews.length).addClass("animated fadeInUp");
				}, 200);
			});
		}
	});
	jQuery('.news-grid').viewportChecker({
		callbackFunction: function(){
			jQuery(".news-item").each(function () {		
				var $latestNews = jQuery(".news-item"), counter = 0;
				setInterval(function(){
				  $latestNews.eq(counter++ % $latestNews.length).addClass("animated fadeInUp");
				}, 200);
			});
		}
	});
	jQuery('.team-members').viewportChecker({
		callbackFunction: function(){
			jQuery(".team-member").each(function () {		
				var $latestNews = jQuery(".team-member"), counter = 0;
				setInterval(function(){
				  $latestNews.eq(counter++ % $latestNews.length).addClass("animated fadeInUp");
				}, 200);
			});
		}
	});
	jQuery('.facts_and_figures').viewportChecker({
		offset: 200,
		callbackFunction: function(){
			countup();
		}
	});
	
	jQuery(window).on("load resize",function(){
		var screenwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		if (screenwidth <= 767) {
			//MatchHeight
			jQuery('.mh-contactHeader').matchHeight({remove: true});
			jQuery('.mh-contactList').matchHeight({remove: true});
			jQuery('.team-mem-info').matchHeight({remove: true});
			jQuery('.top_three_blocks p').matchHeight({remove: true});
			jQuery('.services .half p').matchHeight({remove: true});
			jQuery('.temp-video h3').matchHeight({remove: true});
			//jQuery('.values-box').matchHeight({remove: true});
		}
		if (screenwidth >= 768) {
			//MatchHeight
			jQuery('.mh-contactHeader').matchHeight({byRow: false});
			jQuery('.mh-contactList').matchHeight({byRow: false});
			jQuery('.team-mem-info').matchHeight({byRow: false});
			jQuery('.top_three_blocks p').matchHeight({byRow: false});
			jQuery('.services .half p').matchHeight({byRow: false});
			jQuery('.brochures .half').matchHeight({byRow: true});
			jQuery('.temp-video h3').matchHeight({byRow: false});
			//jQuery('.values-box').matchHeight({byRow: false});
			
		}
	});
	
	jQuery('.values-box').matchHeight({byRow: false});
	
} )();